import React from "react";


const ContactUs = () => {
    return (
        <div className=" text-white p-6 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
        <p className="text-base mb-4">
          For any inquiries or support, please feel free to reach out to us through the following methods:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Email: gauravsingh264209@gmail.com</li>
          <li>Phone: +91 8808511460</li>
          <li>Address: 1234 Main Street, City, U.P , India</li>
        </ul>
        <p className="text-base">
          We look forward to hearing from you!
        </p>
      </div>
    );
};  

export default ContactUs;
